import React, { FC } from 'react';
import { SettingsCardsPageSkeleton } from '../settings/settingsSkeleton';

export const PlatformSelectionPageSkeleton: FC = () => <SettingsCardsPageSkeleton />;
